
<template>
  <div class="container mt-5">
    <header id="page-topbar" style="background-color: #03806a;text-emphasis-color: white;" >
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link tag="a" to="" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
            </span>
          </router-link>
        </div>
        <span toggle-class="header-item" class="pt-3 d-none d-lg-block">
          <span class="h3 text-white"> <b>{{ userData.business }}</b> </span> <br>
          <small class="me-3 text-white"><i class="fas fa-map-marker-alt"></i> {{ userData.location }} </small>
          <small class="text-white"><i class="fas fa-phone-alt"></i> {{ userData.contact }} </small>
        </span>
      </div>

      <div class="d-flex">
        <b-dropdown right variant="white" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle text-white mdi-24px"></i>
            <span class="d-none d-xl-inline-block text-white mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>Logout</a>
        </b-dropdown>
      </div>
    </div>
  </header>
  <br><br>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
            <div><router-link to="/login"><b-button size="sm" variant="primary"><i class="mdi mdi-login"></i> Login</b-button></router-link></div>
            <div><b-button v-b-modal.new-prn size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Subscription</b-button></div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template #cell(updated_at)="data">
                  {{ new Date(data.item.updated_at).toLocaleDateString('en-US', options) }}
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="new-prn" centered title="New Subscription" title-class="font-18" hide-footer>
  
  <form @submit.prevent="pay">

      <div class="form-group mb-2">

          <label>Service</label>

          <v-select :options="services" @input="FindProduct" placeholder="Select a Service" v-model="service"></v-select>

          <!-- <label>Product</label>

          <v-select :options="products" @input="FindPrice" placeholder="Select a Product" v-model="product"></v-select> -->

                          <div class="row">

          <div class="col">

            <label>Package</label>

            <v-select :options="products" @input="FindPrice" placeholder="Select a Package" v-model="product"></v-select>

          </div>

          <div class="col" v-show="service =='Software Subscription' ">
          
            <label>Months to Pay</label>
          
            <input v-model="monthsToPay" @change="CalculateAmount" type="number" min="1" class="form-control" />

          </div>

          </div>
          <label>Amount</label>
        <input v-model="calculatedAmount" type="text" class="form-control" :readonly = "true" />


          <div class="form-group mb-2">

            <label>Mobile Money Number</label>

            <b-input-group prepend="+256"><input v-model="telephone" placeholder="Enter Telephone" v-mask="'#########'" type="text" class="form-control"/></b-input-group>

          </div>

      </div>

      <div class="form-group d-flex justify-content-end">

          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prn')" >Close</b-button>

          <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>

      </div>

  </form>

</b-modal>

    

    <b-modal id="waiting-confirm" centered title-class="font-18" hide-footer>
      <div class="text-center">  
        <b>{{ responseMessage }}</b><br><br>
        <b-spinner class="align-middle" type="grow" style="width: 5rem; height: 5rem;"></b-spinner>
      </div>
      <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('waiting-confirm')" >Close</b-button>
      </div>
    </b-modal>
    
    <b-modal id="payment-success" centered title="Payment Successful" title-class="text-success font-18" hide-footer>
  <div class="text-center">  
    <b class="text-success">{{ responseMessages }}</b><br><br>
  </div>
  <div class="form-group d-flex justify-content-end">
    <b-button 
      type="button" 
      class="btn w-30" 
      variant="success" 
      @click="$bvModal.hide('payment-success')">
      OK
    </b-button>
  </div>
</b-modal>


  </div>
</template>

<script>
import axios from "axios";
// import Layout from "../../layouts/auth";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { subscriptionMethods, subscriptionComputed } from "@/state/helpers";

export default {
  page: {
    title: "Subscriptions",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Subscriptions",
      items: [  {text: "Subscriptions",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'service', label: 'Service', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'updated_at', label: 'Paid On', visible: true },
        ],
      id:'',
      name:'',
      monthsToPay: 1,
      baseAmount:0,
      // services:["Software Subscription","SMS Purchase"], service:"",
      services:["Software Subscription"], service:"",

      products:[], product:"", amount:"",telephone:"", responseMessage:"", 
      options : { weekday: "short", year: "numeric", month: "long", day: "numeric", hour: 'numeric'},
    };
  },
  computed: {
    ...subscriptionComputed,
    List() { return this.subscriptions.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.subscriptions.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.subscriptions.length>0) { a=false;} else { a=true;} return a },
    calculatedAmount() {
      return this.baseAmount * this.monthsToPay;
    },
  },
  
  mounted() {
    this.$bvModal.show('new-prn');
    this.fetchSubscriptions();
    this.TotalRows = this.subscriptions.length;
    this.isBusy=false;
  },
  methods: {
    ...subscriptionMethods,
   
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    FindProduct(){
  
  if (this.service=="Software Subscription") {
    
      // this.products = ["Yearly Subscription","Monthly Subscription"]
      this.products = ["Monthly Subscription"]

  }
   else {

      this.products = ["Starter Pack - 2500 sms","Premium Pack - 5000 sms","Enterprise Pack - 10000 sms"]

  }

  this.product = "";

  this.baseAmount = 0;

  this.amount = 0;

  this.monthsToPay = 1;

  },
  FindPrice(){

// if (this.product=="Yearly Subscription") {

//     this.amount = 500000;

// } 
 if(this.product=="Monthly Subscription"){

    // this.amount = 50000;
    this.baseAmount = this.userData.monthly_charge;

} else if(this.product=="Starter Pack - 2500 sms"){

    this.baseAmount = 1000;

} else if(this.product=="Premium Pack - 5000 sms"){

    this.baseAmount = 30000;

} else if(this.product=="Enterprise Pack - 10000 sms"){

    this.baseAmount = 50000;

} else {

    this.baseAmount = 0;

}

this.CalculateAmount();
},
    CalculateAmount() {
        
        if (!this.monthsToPay || this.monthsToPay < 1) {
  
          this.monthsToPay = 1;
  
        }
  
        this.amount = this.baseAmount * this.monthsToPay;
  
      },
      async pay(){
      let formData = new FormData();
      formData.append("telephone", this.telephone);
      formData.append("amount", this.amount);
      formData.append("service", this.product);
      formData.append('months_paid',this.monthsToPay);
      let url = "/makesubscription";
      await axios.post(url, formData).then((response) => {
      if (response.data.code == 200) {
          this.responseMessage=response.data.message;
          this.$bvModal.hide('new-prn');
          this.$bvModal.show('waiting-confirm');
          this.interval = setInterval(async () => { await this.ConfirmPayment(response.data.reference); }, 5000 * 5);
      }
      });
    },

    async ConfirmPayment(reference){
      let formData = new FormData();
      formData.append("reference", reference);
      let url = "/confirmpayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) { 
          if (response.data.code=='200') {
              this.$bvModal.hide('waiting-confirm');
              clearInterval(this.interval);
              this.fetchSubscriptions();
              this.responseMessages = `${response.data.message} License has been renewed. Please login.`;

              // this.responseMessages=response.data.message +' '+ 'License has been renewed.'+' '+' Please Login';
              this.$bvModal.show('payment-success');
    //          this.$swal({ title:'Success', text:response.data.message + 'License has been renewed. Please Login', icon:'success'});

    // this.$swal.fire({
    //       title: 'Success!',
    //       text: response.data.message + ' Please re-login to extend your license.',
    //       icon: 'success',
    //       confirmButtonText: 'OK',
    //       position: 'center', 
    //       customClass: {
    //         popup: 'swal2-popup', 
    //         title: 'swal2-title',
    //         confirmButton: 'swal2-confirm-button',
    //       },
    //     });

            }
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};

</script>